import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel(
        $ids: [String]
        $title: String
        $category_ids: [String]
        $product_ids: [String]
        $shop_ids: [String]
        $discount_type_ids: [String]
        $coupon_id: String
        $discount_value: String
        $discount_percent: String
        $brand_ids: [String]
        $brand_titles: [String]
        $barcodes: [String]
        $co_price: String
        $co_price_equality: String
        $min_me_price: String
        $min_me_price_equality: String
        $max_me_price: String
        $max_me_price_equality: String
        $created_at: String
        $created_at_equality: String
        $is_active: Int
        $is_exist: Int
        $is_packaged: Int
        $has_wolesale_discount: Int
        $from_sub_childs: Int
        $from_all_shops: Int
        $withs: [String]
        $search_phrase_type: String
        $search_type: String
        $creator_ids: [String]
        $updator_ids: [String]
        $booth_ids: [String]
        $stock: String
        $equivalent_codes: [String]
        $max_number_buy: String
        $for_admin: Int
        $page: Int
        $limit: Int
        $nulls: [String]
        $orderBy_field: String
        $orderBy_direction: String
        $haves: [String]
      ) {
        productShopPanel(
          ids: $ids
          title: $title
          category_ids: $category_ids
          product_ids: $product_ids
          shop_ids: $shop_ids
          discount_type_ids: $discount_type_ids
          coupon_id: $coupon_id
          discount_value: $discount_value
          discount_percent: $discount_percent
          brand_ids: $brand_ids
          brand_titles: $brand_titles
          barcodes: $barcodes
          co_price: $co_price
          co_price_equality: $co_price_equality
          min_me_price: $min_me_price
          min_me_price_equality: $min_me_price_equality
          max_me_price: $max_me_price
          max_me_price_equality: $max_me_price_equality
          created_at: $created_at
          created_at_equality: $created_at_equality
          is_active: $is_active
          is_exist: $is_exist
          is_packaged: $is_packaged
          has_wolesale_discount: $has_wolesale_discount
          from_sub_childs: $from_sub_childs
          from_all_shops: $from_all_shops
          withs: $withs
          search_phrase_type: $search_phrase_type
          search_type: $search_type
          creator_ids: $creator_ids
          updator_ids: $updator_ids
          booth_ids: $booth_ids
          stock: $stock
          equivalent_codes: $equivalent_codes
          max_number_buy: $max_number_buy
          for_admin: $for_admin
          nulls: $nulls
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
          haves: $haves
        ) {
          data {
            id
            stock
            co_price
            me_price
            product_info {
              id
              title
              barcode
              introtext
              brand {
                title
              }
              media {
                full_url
              }
              packaged_items {
                id
              }
            }
            shop {
              title
            }
            booth {
              title
            }
          }
          total
          last_page
        }
      }
    `,
  },
  delete: {
    name: 'deleteProductShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteProductShop($ids: [String]!) {
        deleteProductShop(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String]) {
        product(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel($ids: [String], $for_admin: Int) {
        productShopPanel(ids: $ids, for_admin: $for_admin) {
          data {
            id
            product_info {
              title
              barcode
              brand {
                id
                title
              }
              media {
                full_url
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
